<div class="nested-list">
  @for (reference of block.referenceLinks; track $index; let referenceIndex = $index) {
    <div class="nested-card">
      <div class="nested-header">
        <strong>Reference {{ referenceIndex + 1 }}</strong>
        <button type="button" class="danger small" (click)="removeReference(referenceIndex)">Remove</button>
      </div>
      <label>
        <span>Label</span>
        <input
          [ngModel]="reference.label"
          placeholder="Reference label"
          (ngModelChange)="updateReference(referenceIndex, 'label', $event)" />
      </label>
      <label>
        <span>URL</span>
        <input
          [ngModel]="reference.url"
          placeholder="https://example.com"
          (ngModelChange)="updateReference(referenceIndex, 'url', $event)" />
      </label>
    </div>
  }
</div>

<button type="button" class="ghost small" (click)="addReference()">Add reference</button>
